import React from 'react';
import { Chip } from '@mui/material';
import { Task } from '../../types';

interface TaskPriorityChipProps {
  priority: Task['priority'];
}

export const TaskPriorityChip: React.FC<TaskPriorityChipProps> = ({ priority }) => {
  const getColor = () => {
    switch (priority) {
      case 'high':
        return 'error';
      case 'medium':
        return 'warning';
      default:
        return 'success';
    }
  };

  return (
    <Chip
      label={priority}
      color={getColor()}
      size="small"
      sx={{ textTransform: 'capitalize' }}
    />
  );
};